<template>
  <div class="" style="padding-top: 85px;" id="header">
    <headerList :new_nav="new_nav"></headerList>

    <!-- 轮播图 -->
    <div class="index-swiper relative" v-if="index_swi.length">
      <Carousel v-model="value1" autoplay loop dots="none" auto :height="600" trigger="hover" :autoplay-speed="5000"
        @on-change="changeSwiper">
        <CarouselItem v-for="item in index_swi" :key="item.pub_picBig" class="shou">
          <img class="nav-swiper-img" @click="enterDetail(item.DOC_SOURCEURL)" :src="item.pub_picBig" />
        </CarouselItem>
      </Carousel>

      <!-- 搜索框 -->
      <div class="video-search-box flex absolute">
        <div class="video-filter bg-ff f-16 c-11 flex-c">
          <span class="mr-10">全部</span>
          <!-- <span class="iconfont iconxiangxiajiantou"></span> -->
        </div>
        <div class="flex-box bg-ff flex plr-20">
          <input type="text" v-model="search" class="flex-box f-18 c-33"
            @keyup.enter="enterSearch('SYS_TOPIC_cn', search)" placeholder="请输入关键词搜索">
          <span class="iconfont iconsearch ml-40 c-11 f-22" @click="enterSearch('SYS_TOPIC_cn', search)"></span>
        </div>
      </div>

      <!-- 关键字 -->
      <div class="absolute index-keys-box flex-c">
        <span class="f-14 c-ff mlr-20">关键字:</span>
        <span class="f-14 c-ff mlr-20 key" v-for="item in search_key" @click="enterSearch('SYS_TOPIC_cn', item)"
          :key="item">{{ item }}</span>
      </div>
    </div>

  </div>
</template>

<script>
import headerList from './header_nav.vue'
export default {
  data() {
    return {
      search_key: [],
      value1: 0, // 轮播图索引
      index_swi: [], // 轮播图
      search: '',
      navid: 2,
      new_nav: false
    }
  },

  components: {
    headerList
  },

  props: {
    pagetype: String
  },

  created() {
    this.navid = this.$route.query.navid || 2
    this.bindSwipe(this.pagetype) // 获取轮播
    this.bindSearch() // 获取关键字
    // this.$Spin.show()
  },
  mounted() {
    // 监听页面滚动
    window.addEventListener('scroll', this.scrollToTop)
  },
  methods: {
    // 页面滚动
    scrollToTop() {
      // console.log(document.getElementById('header').getBoundingClientRect().top);
      let scrollTop = document.getElementById('header').getBoundingClientRect().top
      if (scrollTop > -85) {
        this.new_nav = false
      } else {
        this.new_nav = true
      }
    },
    // 获取关键字
    async bindSearch() {
      let _this = this
      const res = await _this.get_res('/search/getHotWords', { size: 5, sld: "AHSCXB" })
      if (res.length) {
        _this.search_key = res
      }
    },

    // 获取轮播图
    async bindSwipe(page) {
      let _this = this
      let data = {
        conditions: JSON.stringify([{ pub_col_id: _this.navid }, { pub_sale_status: 1 }]),
        orderBy: "pub_a_order asc pub_lastmodified desc id asc",
        pageNo: 1,
        pageSize: 15,
        searchText: "",
      }
      const res = await _this.post('/spc/cms/publish/list.do', data)
      // console.log(res)
      if (res.success) {
        _this.index_swi = res.result
      } else {
        _this.$Message.error(res.description);
      }
    },

    // 轮播图切换
    changeSwiper(oldValue, value) {
      // console.log(value)
      this.value1 = value
    },

    // 跳转到链接
    enterDetail(path) {
      path && window.open(path)
    },

    // 进入搜索页面
    enterSearch(field, q) {
      if (q == '') {
        return this.$Message.warning('请输入具体内容');
      }
      // console.log('123')
      // this.$router.push({path: '/search_list',query:{field,q}})

      let link = this.$router.resolve({
        path: '/search_list',
        query: { field, q }
      });
      window.open(link.href, "_blank"); //打开新窗口
    }

  },


}
</script>

<style lang="less">
.ivu-carousel-item {
  // width: 100vw!important;
}

.index-swiper {
  height: 600px;
  width: 100%;
}

.nav-swiper-img {
  height: 600px;
  width: 100%;
}

// 首页搜索框
.index-search-box {
  left: 50%;
  top: 44%;
  transform: translate(-50%, -50%);
  width: 800px;
  height: 80px;
  background: rgba(138, 155, 159, .6);
  padding: 12px 10px;

  .search_btn {
    height: 56px;
    width: 90px;
    background-color: #fff;
  }

  input {
    height: 56px;
    background: rgba(255, 255, 255, .5);
    padding: 0 30px;
  }

  input:placeholder {
    color: #75837e;
  }

  img {
    width: 44px;
    height: 37px;
  }
}

.index-keys-box {
  bottom: 0;
  width: 100%;
  height: 50px;
  background: rgba(0, 0, 0, .5);

  .key {
    cursor: pointer;
    transition: all .3s;
  }

  .key:hover {
    color: red;
  }
}


// 优化搜索框
.video-search-box {
  left: 50%;
  z-index: 100;
  transform: translate(-50%, -50%);
  top: 45% !important;
  width: 540px;
  border-radius: 4px;
  overflow: hidden;

  .video-filter {
    width: 95px;
    height: 50px;
  }

  .flex-box {
    opacity: .85;
    height: 50px;
  }
}
</style>
